export default class UserLoggedController {
  /* @ngInject */
  constructor(AuthService, LoginService) {
    this.authService = AuthService;
    this.loginService = LoginService;
  }

  username() {
    return this.authService.username();
  }

  logout() {
    this.loginService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user-logged/user-logged.controller.js